import { render, staticRenderFns } from "./brokerAccount.vue?vue&type=template&id=2d664dd7&scoped=true"
import script from "./brokerAccount.vue?vue&type=script&lang=js"
export * from "./brokerAccount.vue?vue&type=script&lang=js"
import style0 from "./brokerAccount.vue?vue&type=style&index=0&id=2d664dd7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d664dd7",
  null
  
)

export default component.exports